import style from './produtos.module.css';
import api from '../../../services/api';
import { useNavigate, useLocation } from 'react-router-dom';
import { IoArrowBackCircle } from 'react-icons/io5';
import { useEffect, useState } from 'react';
import { CiZoomIn, CiZoomOut } from 'react-icons/ci';
import { MdOutlineZoomInMap } from 'react-icons/md';

import { TransformWrapper, TransformComponent, useControls } from "react-zoom-pan-pinch";

import selo from '../../../catalogo/assets/selo.png';

//import ImageGallery from "react-image-gallery";
//import "react-image-gallery/styles/css/image-gallery.css";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';



function Produtos() {

    const Controls = () => {
        const { zoomIn, zoomOut, resetTransform } = useControls();

        return (
            <div className={style.zoom}>
                <CiZoomIn className={style.btn} onClick={() => zoomIn()} />
                <CiZoomOut className={style.btn} onClick={() => zoomOut()} />
                <MdOutlineZoomInMap className={style.btn} onClick={() => resetTransform()} />
            </div>
        );
    };


    const navigate = useNavigate();
    const loca = useLocation();


    const [produtos, setProdutos] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [cores, setCores] = useState([]);
    const [comps, setComps] = useState([]);
    const [img, setImg] = useState([]);

    const [prod, setProd] = useState([]);
    const [subtipos, setSubtipos] = useState([]);





    const [imagem, setImagem] = useState('');
    const [categoria, setCategoria] = useState('');
    const [material, setMaterial] = useState('');
    const [linha, setLinha] = useState('');
    const [nompro, setNompro] = useState('');
    const [sku, setSku] = useState(0);
    const [codcor, setCodcor] = useState(0);
    const [compri, setCompri] = useState('');
    const [codtip, setCodtip] = useState(0);
    const [prolan, setProlan] = useState(0);
    const [subtipo, setSubtipo] = useState(0);



    //FIltra produtos conforme tipo 
    function FilProdutosT(wcodtip) {
        GetCores(loca.state.codlin, wcodtip);
        GetComp(loca.state.codlin, codcor, wcodtip);

        let prod = produtos.filter(item => item.codcla == wcodtip && item.codcor == codcor);



        if (prod.length > 0) {

            /*let sub = prod.filter(item => item.subtip > 0);
            if (sub.length > 0) {
                let temp = [];
                sub.map((item) => {

                    let index = temp.findIndex(val => val.subtip === item.subtip);

                    if (index < 0) {
                        temp.push({
                            subtip: item.subtip,
                            dessub: item.dessubtip

                        })

                    }

                })
                setSubtipos(temp);
                FilProdutosSubtipo(temp[0].subtip);


            }*/



            setProd(prod);
            setNompro(prod[0].nompro)
            setCategoria(prod[0].categoria)
            setMaterial(prod[0].material)
            setLinha(prod[0].linha)
            setSku(prod[0].codpro);

            setCodtip(prod[0].codcla);
            setCodcor(prod[0].codcor);
            setCompri(prod[0].compri);
            setProlan(prod[0].prolan);
            setSubtipo(prod[0].subtip);


            setImagem(prod[0].imgurl);
            //AtulizaImg('SEQ' + prod[0].seqimg);
            //AtulizaCor('COR' + prod[0].codcor, prod[0].codcor, 0);

            //AtulizaComp('COMP' + prod[0].compri, prod[0].compri, 0);

        } else {
            prod = produtos.filter(item => item.codcla == wcodtip);

            /* let sub = prod.filter(item => item.subtip > 0);
             if (sub.length > 0) {
                 let temp = [];
                 sub.map((item) => {
 
                     let index = temp.findIndex(val => val.subtip === item.subtip);
 
                     if (index < 0) {
                         temp.push({
                             subtip: item.subtip,
                             dessub: item.dessubtip
 
                         })
 
                     }
 
                 })
                 setSubtipos(temp);
                 FilProdutosSubtipo(temp[0].subtip);
 
             }*/

            if (prod.length > 0) {
                setProd(prod);
                setNompro(prod[0].nompro)
                setCategoria(prod[0].categoria)
                setMaterial(prod[0].material)
                setLinha(prod[0].linha)
                setSku(prod[0].codpro);

                setCodtip(prod[0].codcla);
                setCodcor(prod[0].codcor);
                setCompri(prod[0].compri);
                setProlan(prod[0].prolan);
                setSubtipo(prod[0].subtip);


                setImagem(prod[0].imgurl);
                //AtulizaImg('SEQ' + prod[0].seqimg);
                //AtulizaCor('COR' + prod[0].codcor, prod[0].codcor, 0);
                // AtulizaComp('COMP' + prod[0].compri, prod[0].compri, 0);
            } else {
                setProd([]);
                setNompro('')
                setCategoria('')
                setMaterial('')
                setLinha('')
                setSku(0);
                setImagem('');
            }
        }
    }

    //FIltra produtos conforme cor 
    function FilProdutosCor(wcodcor) {
        GetComp(loca.state.codlin, wcodcor, codtip);

        let prod = produtos.filter(item => item.codcla == codtip && item.codcor == wcodcor && item.compri == compri);

        if (prod.length > 0) {
            setProd(prod);

            setNompro(prod[0].nompro)
            setCategoria(prod[0].categoria)
            setMaterial(prod[0].material)
            setLinha(prod[0].linha)
            setSku(prod[0].codpro);


            setCodcor(prod[0].codcor);
            setCompri(compri);
            setProlan(prod[0].prolan);
            setSubtipo(prod[0].subtip);


            setImagem(prod[0].imgurl);
            AtulizaImg('SEQ' + prod[0].seqimg);

            AtulizaComp('COMP' + compri, compri, 0);
        } else {
            prod = produtos.filter(item => item.codcla == codtip && item.codcor == wcodcor);

            setProd(prod);

            setNompro(prod[0].nompro)
            setCategoria(prod[0].categoria)
            setMaterial(prod[0].material)
            setLinha(prod[0].linha)
            setSku(prod[0].codpro);


            setCodcor(prod[0].codcor);
            setCompri(prod[0].compri);
            setProlan(prod[0].prolan);
            setSubtipo(prod[0].subtip);


            setImagem(prod[0].imgurl);
            AtulizaImg('SEQ' + prod[0].seqimg);
            AtulizaComp('COMP' + prod[0].compri, prod[0].compri, 0);
        }


    }

    //FIltra produtos conforme comprimento 
    function FilProdutosCompri(wcompri) {
        let prod = produtos.filter(item => item.codcla == codtip && item.codcor == codcor && item.compri == wcompri);

        if (prod.length > 0) {
            setProd(prod);

            setNompro(prod[0].nompro)
            setCategoria(prod[0].categoria)
            setMaterial(prod[0].material)
            setLinha(prod[0].linha)
            setSku(prod[0].codpro);


            setCodcor(codcor);
            setCompri(prod[0].compri);
            setProlan(prod[0].prolan);
            setSubtipo(prod[0].subtip);


            setImagem(prod[0].imgurl);
            AtulizaImg('SEQ' + prod[0].seqimg);
            AtulizaCor('COR' + codcor, codcor, 0);
        } else {
            prod = produtos.filter(item => item.codcla == codtip && item.compri == wcompri);
            setProd(prod);

            setNompro(prod[0].nompro)
            setCategoria(prod[0].categoria)
            setMaterial(prod[0].material)
            setLinha(prod[0].linha)
            setSku(prod[0].codpro);


            setCodcor(prod[0].codcor);
            setCompri(prod[0].compri);
            setProlan(prod[0].prolan);
            setSubtipo(prod[0].subtip);


            setImagem(prod[0].imgurl);
            AtulizaImg('SEQ' + prod[0].seqimg);
            AtulizaCor('COR' + prod[0].codcor, prod[0].codcor, 0);
        }

    }

    //FIltra produtos conforme comprimento 
    function FilProdutosSubtipo(wsubtip) {
        let prod = produtos.filter(item => item.subtip == wsubtip);

        setProd(prod);

        setNompro(prod[0].nompro)
        setCategoria(prod[0].categoria)
        setMaterial(prod[0].material)
        setLinha(prod[0].linha)
        setSku(prod[0].codpro);


        setCodcor(codcor);
        setCompri(prod[0].compri);
        setProlan(prod[0].prolan);
        setSubtipo(prod[0].subtip);


        setImagem(prod[0].imgurl);
        AtulizaImg('SEQ' + prod[0].seqimg);
        AtulizaCor('COR' + codcor, codcor, 0);
        AtulizaSubtipo('SUB' + prod[0].subtip, prod[0].subtip, 0);


    }




    //Filtra mini imagens
    function GetImg(data) {
        let temp = [];
        let temp1 = data;
        temp1.map((item) => {
            if (item.codcla == codtip && item.compri == compri && item.codcor == codcor) {
                temp.push({
                    val: item.imgurl,
                    seqimg: item.seqimg
                })
            }
        })
        setImg(temp);

    }


    //Filtro de Tipos*********************************************************
    async function GetTipo(wcodcla) {
        await api.get(`catalogo/tipos/?codcla=${wcodcla}`)
            .then((resposta) => {
                setTipos(resposta.data);


                AtulizaTipo('TIPO' + resposta.data[0].codcla, resposta.data[0].codcla);




            }).catch((erro) => {

            })
    }
    //***********************************************************************

    //Filtro de Cores*********************************************************
    async function GetCores(wcodcla, wcodtip) {
        await api.get(`catalogo/cores/?codcla=${wcodcla}&codtip=${wcodtip}`)
            .then((resposta) => {
                setCores(resposta.data);

                //AtulizaCor('COR' + codcor, codcor, 0);

            }).catch((erro) => {

            })
    }
    //***********************************************************************

    async function GetComp(wcodcla, wcodcor, wcodtip) {
        await api.get(`catalogo/compri/?codcla=${wcodcla}&codtip=${wcodtip}&codcor=${wcodcor}`)
            .then((resposta) => {
                setComps(resposta.data);

                //AtulizaComp('COMP'+compri,compri,0);

                //AtulizaComp('COMP' + resposta.data[0].compri, resposta.data[0].compri, 0);

            }).catch((erro) => {

            })
    }

    function TrocaImagem(wurl) {
        setImagem(wurl);
    }

    function RemoveTipo() {
        tipos.map((item) => {
            const wele = document.querySelector('#' + 'TIPO' + item.codcla);
            wele.classList.remove(style.itemtiposel);
        })
    }

    function AtulizaTipo(wclasse, wcodtip) {
        RemoveTipo();


        const welement = document.querySelector('#' + wclasse);
        welement.classList.add(style.itemtiposel);

        setCodtip(wcodtip);


        FilProdutosT(wcodtip);

    }

    function RemoveImg() {
        img.map((item) => {
            const wele = document.querySelector('#' + 'SEQ' + item.seqimg);
            wele.classList.remove(style.itemimgsel);
        })
    }

    function AtulizaImg(wclasse) {
        RemoveImg();
        const welement = document.querySelector('#' + wclasse);
        welement.classList.add(style.itemimgsel);
    }

    function RemoveCor() {
        cores.map((item) => {
            const wele = document.querySelector('#' + 'COR' + item.codcor);
            wele.classList.remove(style.itemcorsel);
        })
    }

    function AtulizaCor(wclasse, wcodcor, wmuda) {
        RemoveCor();
        const welement = document.querySelector('#' + wclasse);
        welement.classList.add(style.itemcorsel);

        setCodcor(wcodcor);


        if (wmuda == 1) {
            FilProdutosCor(wcodcor);
        }


    }


    function RemoveComp() {
        comps.map((item) => {
            const wele = document.querySelector('#' + 'COMP' + item);
            wele.classList.remove(style.itemcomprisel);
        })
    }

    function AtulizaComp(wclasse, wcompri, wmuda) {
        RemoveComp();
        const welement = document.querySelector('#' + wclasse);
        welement.classList.add(style.itemcomprisel);

        setCompri(wcompri);

        if (wmuda == 1) {
            FilProdutosCompri(wcompri);
        }


    }

    function RemoveSubtipo() {
        subtipos.map((item) => {
            const wele = document.querySelector('#' + 'SUB' + item.subtip);
            wele.classList.remove(style.itemcomprisel);
        })
    }

    function AtulizaSubtipo(wclasse, wsubtip, wmuda) {
        RemoveSubtipo();
        const welement = document.querySelector('#' + wclasse);
        welement.classList.add(style.itemcomprisel);

        setSubtipo(wsubtip);

        if (wmuda == 1) {
            FilProdutosSubtipo(wsubtip);
        }
    }

    async function GetProdutos(wcodcla, wcodtip, wcompri, wcodcor) {
        await api.get(`catalogo/produtos/?codcla=${wcodcla}&codtip=${wcodtip}&compri=${wcompri}&codcor=${wcodcor}`)
            .then((resposta) => {
                setProdutos(resposta.data);

                setNompro(resposta.data[0].nompro)
                setCategoria(resposta.data[0].categoria)
                setMaterial(resposta.data[0].material)
                setLinha(resposta.data[0].linha)
                setSku(resposta.data[0].codpro);

                setCodtip(resposta.data[0].codcla);
                setCodcor(resposta.data[0].codcor);
                setCompri(resposta.data[0].compri);
                setProlan(resposta.data[0].prolan);
                setSubtipo(resposta.data[0].subtip);




                setImagem(resposta.data[0].imgurl);
                AtulizaImg('SEQ' + resposta.data[0].seqimg);



            }).catch((erro) => {

            })
    }

    useEffect(() => {
        GetProdutos(loca.state.codlin, 0, 0, 0);

    }, [])

    useEffect(() => {
        GetTipo(loca.state.codlin);
        GetCores(loca.state.codlin, codtip);
        GetComp(loca.state.codlin, codcor, codtip);
        GetImg(produtos);

    }, [produtos])


    useEffect(() => {
        GetImg(prod);


        //if (subtipos.length > 0) {
        //    AtulizaSubtipo('SUB' + subtipo, subtipo, 0);
        //}


    }, [prod])



    return (
        <div className={style.content}>
            <div className={style.menuhome}>
                <div className={style.menuhomecontent}>
                    <IoArrowBackCircle className={style.iconmenu} onClick={() => navigate('/catalogo/menu', { state: { codcla: loca.state.codcla } })} />
                    <div className={style.nompro}><a>{nompro}</a></div>
                </div>
            </div>

            <div className={style.detalhe}>
                <div className={style.header}>
                    <a>{categoria} DE {material}</a>
                    <span>{linha}</span>
                    <a>SKU : {sku}</a>
                </div>

                <div className={style.filtros}>
                    <div className={style.comprimentos}>
                        {comps.map((item) => {
                            return (
                                <div id={'COMP' + item} key={item} className={style.itemcomp} onClick={() => AtulizaComp('COMP' + item, item, 1)}>
                                    <a>{item}</a>
                                </div>
                            )
                        })}

                    </div>

                    {subtipo > 999999 ?
                        <div className={style.subtipo}>
                            {subtipos.map((item) => {
                                return (
                                    <div id={'SUB' + item.subtip} key={item.subtip} className={style.itemsubtipo} onClick={() => AtulizaSubtipo('SUB' + item.subtip, item.subtip, 1)}>
                                        <a>{item.dessub}</a>
                                    </div>
                                )
                            })}

                        </div> : null}

                    {prolan == 1 ?
                        <div className={style.selolan}>
                            <img src={selo}></img>
                        </div> : null}

                    <div id="box" className={style.imagem}>
                        <TransformWrapper
                            initialScale={1}
                            initialPositionX={200}
                            initialPositionY={100}
                        >
                            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                                <>
                                    <TransformComponent>
                                        {/*<img id="img" src={imagem} ></img>*/}
                                        < LazyLoadImage
                                        alt={''}
                                        effect="blur"
                                        wrapperProps={{
                                            // Se precisar, você pode ajustar a transição do efeito usando o estilo do wrapper. 
                                            style: { transitionDelay: "1s" },
                                        }}
                                        src={imagem} />
                                    </TransformComponent>
                                    <Controls />
                                </>
                            )}
                        </TransformWrapper>
                    </div>

                    <div className={style.miniimagem}>
                        {img.map((item) => {
                            return (
                                <div id={'SEQ' + item.seqimg} className={style.itemimg} onClick={() => AtulizaImg('SEQ' + item.seqimg)}>
                                    {/*<img onClick={() => TrocaImagem(item.val)} src={item.val}  ></img>*/}
                                    < LazyLoadImage
                                        alt={''}
                                        effect="blur"
                                        wrapperProps={{
                                            // Se precisar, você pode ajustar a transição do efeito usando o estilo do wrapper. 
                                            style: { transitionDelay: "1s" },
                                        }}
                                        src={item.val} onClick={() => TrocaImagem(item.val)}/>
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div className={style.rodape}>
                    <div className={style.cores}>
                        {cores.map((item) => {
                            return (
                                <div id={'COR' + item.codcor} className={style.itemcor} key={item.codcor} onClick={() => AtulizaCor('COR' + item.codcor, item.codcor, 1)}>
                                    <img src={item.imgurl}></img>
                                </div>
                            )
                        })}


                    </div>


                    <div className={style.tipos}>
                        {tipos.map((item) => {
                            return (
                                <div id={'TIPO' + item.codcla} className={style.itemtipo} key={item.codcla} onClick={() => AtulizaTipo('TIPO' + item.codcla, item.codcla)}>
                                    <a>{item.descla}</a>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>



        </div>
    )
}


export default Produtos;